<template>
  <v-app style="min-height: 100vh; width: 100%; overflow-x: hidden">
    <NavBar
      v-if="
        $route.path != null &&
        $route.path.toLocaleLowerCase() != '/login' &&
        $route.path.toLocaleLowerCase() != '/redirectfromlogin' &&
        $route.path.toLocaleLowerCase() != '/loginsnippet' &&
        !$route.path.toLocaleLowerCase().includes('error')
      " v-model:imageLogo="LoginLogo"
      myEvent="LoginLogo"
    />

    <!-- <v-content> -->

    <v-main
      style="
        min-height: calc(100vh - 64px);
        width: 100%;
        flex: 1;
        overflow-x: hidden;
        background-color: #ffffff;
        top: 0 !important;
      "
      :style="(isFullStreamReDesignRoute ? 'padding-top: 25px !important' : isFlowCreatorRoute ? 'padding-top: 10px !important;padding-bottom: 15px !important;' : '')"
    >
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Cookies from "js-cookie";
import NavBar from "./components/NavBar.vue";
import Swal from "sweetalert2";
import { ref, computed, toRef } from "vue";
import { mapState, useStore } from "vuex";
import { normalizeCharacterLimit, DEFAULT_CHAT_INPUT_LIMIT } from '@/utils/chatInputLimit';

const FULLSTREAM_THEME_DEFAULTS = {
  welcomeTitle: "Welcome to Chat Framework",
  welcomeSubtitle: "How can I help you today?",
  disclaimerText: "AI can make mistakes. Please double-check responses.",
  headerBackgroundColor: null,
  headerTextColor: null,
  headerIconColor: null,
  chatAccentColor: null,
};

export default {
  name: "App",
  provide() {
    const tabSocialType = ref(this.tabSocialTypeData);

    return {
      getStartUpImage: this.GetStartUpImage,
      Click_History_List: this.Click_History_List,
      DeleteTopicStream: this.DeleteTopicStream,
      RenameClick: this.RenameClick,
      RenameTopicStream: this.RenameTopicStream,
      keyupKeyRename: this.keyupKeyRename,
      SetStatusKeyRename: this.SetStatusKeyRename,
      GetModelFirst_Value: this.GetModelFirst_Value,
      GetModelFirst: this.GetModelFirst,
      getIMG: this.getIMG,
      NotificationTokenExpired: this.NotificationTokenExpired,
      isFeedback: ref(this.isFeedback),
      User_Id_Show: ref(this.User_Id_ShowData),
      User_Id: ref(this.User_IdData),
      Time_Delay: ref(this.Time_DelayData),
      flagShowTopic: ref(this.flagShowTopicData),
      listTopic: toRef(this, "listTopicData"),
      TopicName: toRef(this, "TopicNameData"),
      ModelFirst: toRef(this, "ModelFirstData"),
      firstModel: toRef(this, "firstModel"),
      ChatbotName: toRef(this, "ChatbotNameData"),
      Loading_History_Status: toRef(this, "Loading_History_Status"),
      Log_History_TopicID: toRef(this, "Log_History_TopicIDData"),
      IsAllowImage: toRef(this, "IsAllowImage"),
      maximumChatInput: toRef(this, "maximumChatInput"),
      Username: toRef(this, "username"),
      RoleId: toRef(this, "roleId"),
      Log_History_Take: toRef(this, "Log_History_TakeData"),
      Log_History_ID: toRef(this, "Log_History_IDData"),
      tabSocialType,
      resetUnreadNotifications: () => {
        const clearedTabs = tabSocialType.value.map((item) => ({
          ...item,
          unreadCount: 0,
        }));

        tabSocialType.value.splice(0, tabSocialType.value.length, ...clearedTabs);
        this.tabSocialTypeData = tabSocialType.value;
        this.unreadCountData = 0;
      },
      KeyTopic: toRef(this, "KeyTopicData"),
      Snippet_Status: ref(this.Snippet_StatusData),
      Snippet_Username: ref(this.Snippet_UsernameData),
      isAllowLLMChange: toRef(this, "isAllowLLMChange"),
      selectedLLMModelInChat: toRef(this, "selectedLLMModel"),
      setSelectedLLMModelInChat: (model) => {
        this.selectedLLMModel = model;
      },
      TopicModelID: toRef(this, "TopicModelIDData"),
      lastLLMID: toRef(this, "lastLLMID"),
      setLastLLMIDInChat: (id) => {
        this.lastLLMID = id;
      },

      // appState: reactive({
      //   colorThemeChat: toRef(this, "colorThemeChat")
      // }),
      colorThemeChat: computed(() => this.colorThemeChat),
      SnippedcolorThemeChat: computed(() => this.SnippedcolorThemeChat),
      SnippedIcon: computed(() => this.SnippedIconData),
      SnippedIconColor: computed(() => this.SnippedIconColorData),
      SnippedHeaderColorTheme: computed(() => this.SnippedHeaderColorThemeData),
      SnippedFontColorTheme: computed(() => this.SnippedFontColorThemeData),
      // Snippet panel config (keys ตรงกับ inject ของ Snippet.vue เป๊ะ — camelCase snipped*)
      // ค่าดิบ (null/true/false/string): default เป็นหน้าที่ของ Snippet.vue (backward-compat)
      snippedShowModelTopicBar: computed(() => this.SnippedShowModelTopicBarData),
      snippedTypingText: computed(() => this.SnippedTypingTextData),
      snippedInputPlaceholder: computed(() => this.SnippedInputPlaceholderData),
      snippedDisclaimerText: computed(() => this.SnippedDisclaimerTextData),
      // R2 display settings — ค่าดิบเช่นกัน (null = ไม่เคยตั้ง) Snippet.vue เป็นคนตัดสิน default
      snippedBotBubbleColor: computed(() => this.SnippedBotBubbleColorData),
      snippedBotFontColor: computed(() => this.SnippedBotFontColorData),
      snippedSendButtonColor: computed(() => this.SnippedSendButtonColorData),
      snippedSendButtonVariant: computed(() => this.SnippedSendButtonVariantData),
      snippedShowVersion: computed(() => this.SnippedShowVersionData),
      snippedShowCharCounter: computed(() => this.SnippedShowCharCounterData),
      snippedShowSnippedIcon: computed(() => this.SnippedShowSnippedIconData),
      ChatPanelHeaderColorTheme: computed(() => this.ChatPanelHeaderColorThemeData),
      ChatPanelFontColorTheme: computed(() => this.ChatPanelFontColorThemeData),
      flagNav: computed(() => this.flagNav),
      LoginLogo: computed(() => this.LoginLogo),
      IconChat: computed(() => this.IconChat),
      ChatbotIcon: computed(() => this.ChatbotIcon),
      NavbarIcon: computed(() => this.NavbarIcon),
      SnippedLogo: computed(() => this.SnippedLogo),
      // ChatbotName: computed(() => this.ChatbotNameData),
      FontColorTitle: computed(() => this.FontColorTitle),
      NavbarBackGround: computed(() => this.NavbarBackGround),
      SubNavbarBackGround: computed(() => this.SubNavbarBackGround),
      unreadCount: computed(() => this.unreadCountData),
      Status_Error: computed(() => this.Status_ErrorData),
      User_Id_Status: computed(() => this.User_Id_StatusData),
      LeftNavBar: computed(() => this.LeftNavBarData),
      SetPopup: ref(this.SetPopupData),
      flagGetAllTopic: computed(() => this.flagGetAllTopicData),
      miniVariant: computed(() => this.miniVariantData),
      NavbarTxtColorTheme: computed(() => this.NavbarTxtColorThemeData),
      NavbarBtnColorTheme: computed(() => this.NavbarBtnColorThemeData),
      FullstreamWelcomeTitle: computed(() => this.FullstreamWelcomeTitleData),
      FullstreamWelcomeSubtitle: computed(() => this.FullstreamWelcomeSubtitleData),
      FullstreamDisclaimerText: computed(() => this.FullstreamDisclaimerTextData),
      FullstreamNavbarBtnColorTheme: computed(() => this.FullstreamNavbarBtnColorThemeData),
      FullstreamNavbarTxtColorTheme: computed(() => this.FullstreamNavbarTxtColorThemeData),
      FullstreamNavbarIconColorTheme: computed(() => this.FullstreamNavbarIconColorThemeData),
      FullstreamChatColorTheme: computed(() => this.FullstreamChatColorThemeData),
      auth_token: computed(() => this.auth_tokenData),
      TopicModelID_long: toRef(this, "TopicModelID_longData"),
      StatusKeyRename: computed(() => this.StatusKeyRenameData),
      Flag_Click_History: computed(() => this.Flag_Click_HistoryData),
      isImgIconChat: computed(() => this.isImgIconChatData),
      Region: computed(() => this.Region),
      SubscriptionKey: computed(() => this.SubscriptionKey),
      IsChainMassage: computed(() => this.IsChainMassage),
      FileUploadLimit: computed(() => this.FileUploadLimit),
      
    };
  },
  setup() {
    const store = useStore();

    return { store };
  },
  components: {
    NavBar,
  },
  computed: {
    ...mapState(['Snippet_StatusData', {
      isDrawerActuallyOpen: (state) => state.isDrawerOpen,
    }]),
    isFullStreamReDesignRoute() {
      return this.$route.name === "FullStream";
    },
    isFlowCreatorRoute() {
      return this.$route.name === "FlowCreator";
    },
  },
  data() {
    return {
      isTextToImageModel: false,
      isAllowLLMChange: false,
      selectedLLMModel: null,
      FileUploadLimit: null,
      maximumChatInput: DEFAULT_CHAT_INPUT_LIMIT, // ค่าก่อนโมเดลโหลดเสร็จ ต้องผ่อนไว้ ด่านจริงอยู่ที่ backend
      Region: import.meta.env.VITE_APP_Region,
      SubscriptionKey: import.meta.env.VITE_APP_SubscriptionKey,
      IsChainMassage: false,
      listTopicData: [], // [ { "topicID": 60, "topicName": "ABC", "status": false },]
      Flag_Click_Rename: false,
      Flag_Click_HistoryData: false,
      Loading_History_Status: false,

      Log_History_TakeData: 5,
      // Log_History_TopicID: null,
      Log_History_TopicIDData: -1,

      Log_History_IDData: null,

      KeyTopicData: null,
      // KeyTopic: "d332ccb2-b020-4373-a8de-8fe722651bec",

      TopicNameData: "",

      //TopicModelID : "1"

      TopicModelIDData: "",
      TopicModelID_longData: -1,
      StatusKeyRenameData: false,
      ModelFirstData: "-",
      firstModel: "-",
      isFeedback: false,
      auth_tokenData: null,

      ChatbotNameData: "Chatbot",
      ChatbotIcon: null,
      FontColorTitle: null,
      colorThemeChat: null,
      NavbarBtnColorThemeData: null,
      NavbarTxtColorThemeData: null,
      FullstreamWelcomeTitleData: FULLSTREAM_THEME_DEFAULTS.welcomeTitle,
      FullstreamWelcomeSubtitleData: FULLSTREAM_THEME_DEFAULTS.welcomeSubtitle,
      FullstreamDisclaimerTextData: FULLSTREAM_THEME_DEFAULTS.disclaimerText,
      FullstreamNavbarBtnColorThemeData: FULLSTREAM_THEME_DEFAULTS.headerBackgroundColor,
      FullstreamNavbarTxtColorThemeData: FULLSTREAM_THEME_DEFAULTS.headerTextColor,
      FullstreamNavbarIconColorThemeData: FULLSTREAM_THEME_DEFAULTS.headerIconColor,
      FullstreamChatColorThemeData: FULLSTREAM_THEME_DEFAULTS.chatAccentColor,
      isImgIconChatData: null,
      SnippedcolorThemeChat: null,
      SnippedIconData: null,
      SnippedIconColorData: null,
      SnippedHeaderColorThemeData: null,
      SnippedFontColorThemeData: null,
      SnippedShowModelTopicBarData: null,
      SnippedTypingTextData: null,
      SnippedInputPlaceholderData: null,
      SnippedDisclaimerTextData: null,
      SnippedBotBubbleColorData: null,
      SnippedBotFontColorData: null,
      SnippedSendButtonColorData: null,
      SnippedSendButtonVariantData: null,
      SnippedShowVersionData: null,
      SnippedShowCharCounterData: null,
      SnippedShowSnippedIconData: null,
      ChatPanelHeaderColorThemeData: null,
      ChatPanelFontColorThemeData: null,
      LoginLogo: null,
      IconChat: null,
      NavbarIcon: null,
      NavbarBackGround: null,
      SubNavbarBackGround: null,
      SnippedLogo: null,
      IsAllowImage: false,
      flagNav: false,
      lastLLMID: null,
      countff: 0,
      // headerTitle: "@/assets/images/Rectangle 51.png",
      // headerCover: "@/assets/images/Rectangle 51.png",
      // headerC: "@/assets/images/Rectangle 51.png",
      parameterURL: [],
      tabSocialTypeData: [
        { text: "All", value: "All", unreadCount: 0 },
        { text: "Facebook", value: "Facebook", unreadCount: 0 },
        { text: "Line", value: "Line", unreadCount: 0 },
        { text: "Instagram", value: "Instagram", unreadCount: 0 },
      ],
      unreadCountData: 0,
      Status_ErrorData: false,
      Snippet_UsernameData: "",
      Snippet_StatusData: false,
      User_Id_ShowData: "",
      User_IdData: "",
      User_Id_Status: false,
      Time_DelayData: 65,
      flagShowTopicData: true,
      LeftNavBarData: true,
      SetPopupData: false,
      flagGetAllTopicData: false,
      miniVariantData: false,
      username : null,
      roleId: null
    };
  },
  methods: {
    SetStatusKeyRename(stat){
      this.StatusKeyRename = stat;
    },
    keyupKeyRename() {
      if (event.key != "Enter") {
        this.StatusKeyRenameData = true;
      }
    },
    clearInfo() {
      this.listTopicData = [];
      this.TopicNameData = "";
      this.TopicModelIDData = "";
      this.TopicModelID_longData = "";
      this.ModelFirstData = "-";

      this.KeyTopicData = null;
      this.Log_History_TopicIDData = -1;
      this.Log_History_IDData = null;
      this.Flag_Click_Rename = false;
      this.Flag_Click_HistoryData = false;
      this.Loading_History_Status = false;
      this.isFeedback = false;
      this.Log_History_TakeData = 5;
    },
    Click_History_List(
      _Log_History_TopicID,
      _TopicName,
      _TopicModelID,
      _topicModelID_long,
      _keyTopic
    ) {
      this.Log_History_TopicIDData = _Log_History_TopicID;
      this.Log_History_IDData = null;

      this.Flag_Click_HistoryData = !this.Flag_Click_HistoryData;
      this.TopicNameData = _TopicName;

      this.TopicModelIDData = _TopicModelID;
      this.TopicModelID_longData = _topicModelID_long;

      this.ModelFirstData = _TopicModelID;
      this.KeyTopicData = _keyTopic;

      if (_Log_History_TopicID == -1) {
        if (this.listTopicData != null && this.listTopicData.length > 0) {
          if (this.listTopicData[0].topicID == -1) {
            this.listTopicData = this.listTopicData.slice(1, this.listTopicData.length);

            this.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: "",
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(this.listTopicData);
          } else {
            this.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: "",
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(this.listTopicData);
          }
        } else {
          this.listTopicData = [
            {
              topicID: _Log_History_TopicID,
              topicName: _TopicName,
              keyTopic: "",
              status: false,
              topicModelID_long: _topicModelID_long,
              topicModelID: _TopicModelID,
            },
          ];
        }
      }
    },
    RenameClick(iTopic, TopicId) {
      iTopic.status = true;
      this.StatusKeyRenameData = false;

      //(iTopic.TopicRef != null ? : fa)

      const _TopicId = document.getElementById(TopicId);
      if (_TopicId != undefined && _TopicId != null) {
        // _TopicId
        this.$nextTick(() => {
          _TopicId.focus();
        });
      }
    },

    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(
          16
        )
      );

      return Uuid;
    },
    RenameTopicStream(_TopicID, _KeyTopic, _topicName, index, tempAuth_token) {
      try {
        if (_KeyTopic == null || _KeyTopic == "" || _TopicID == -1) {
          _KeyTopic = this.GetUuidv4_Fun();
        }
        if (_TopicID == -1) {
          _KeyTopic = this.GetUuidv4_Fun();
        }

        this.StatusKeyRenameData = false;
        let _Data = {
          TopicID: _TopicID == null ? -1 : _TopicID,
          TopicName: _topicName,
          USER_CHANNEL: this.User_IdData,
          KeyTopic: _KeyTopic,
        };

        this.$call.RenameTopicStream(
          _Data,
          tempAuth_token,
          (response) => {
            if (response.status == 0) {
              if (_TopicID == -1) {
                this.listTopicData[index].topicID = response.data;

                this.Log_History_TopicIDData = response.data;
                this.TopicNameData = _topicName;
              }

              if (this.Log_History_TopicIDData == _TopicID) {
                this.TopicNameData = _topicName;
              }

              this.Flag_Click_HistoryData = !this.Flag_Click_HistoryData;

              console.log("RenameTopicStream OK");
            } else if (response.message == "Token has expired!!!") {
              that.NotificationTokenExpired();
            } else {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: response.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
          () => {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: "",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        );
      } catch {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    DeleteTopicStream(_TopicID, _KeyTopic, _indexTopic) {
      try {
        let _User_Id = {
          TopicID: _TopicID,
          KeyTopic: _KeyTopic,
          USER_CHANNEL: this.User_IdData,
        };

        if (_TopicID == -1) {
          this.listTopicData.splice(_indexTopic, 1);
        } else {
          this.$call.DeleteTopicStream(
            _User_Id,
            (response) => {
              if (response.status == 0) {
                this.listTopicData.splice(_indexTopic, 1);

                if (_User_Id.TopicID == this.Log_History_TopicIDData) {
                  if (this.listTopicData.length > 0) {
                    if (
                      this.listTopicData.length > _indexTopic - 1 &&
                      _indexTopic - 1 > 0
                    ) {
                      this.TopicNameData = this.listTopicData[_indexTopic - 1].topicName;

                      this.Log_History_TopicIDData =
                        this.listTopicData[_indexTopic - 1].topicID;
                      this.Log_History_IDData = null;
                      this.Flag_Click_HistoryData = !this.Flag_Click_HistoryData;
                    } else {
                      this.TopicNameData = this.listTopicData[0].topicName;

                      this.Log_History_TopicIDData = this.listTopicData[0].topicID;

                      this.Log_History_IDData = null;
                      this.Flag_Click_HistoryData = !this.Flag_Click_HistoryData;
                    }
                  } else {
                    this.TopicNameData = "";
                    this.Log_History_TopicIDData = -1;
                    this.Log_History_IDData = null;
                    this.Flag_Click_HistoryData = !this.Flag_Click_HistoryData;
                  }
                }
              } else {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: response.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            },
            () => {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          );
        }
      } catch {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    getSessionStorageValue(key) {
      const value = sessionStorage.getItem(key);
      return value != undefined && value != null ? value : null;
    },
    getParameterUrlValue(key) {
      if (this.parameterURL != null && this.parameterURL != []) {
        return this.parameterURL[key] == undefined ? null : this.parameterURL[key];
      }

      return null;
    },
    getModelFirstValueFromStorageOrUrl(storageKey, urlKey) {
      const storageValue = this.getSessionStorageValue(storageKey);
      if (storageValue != null) {
        return storageValue;
      }

      const parameterValue = this.getParameterUrlValue(urlKey);
      return parameterValue == null ? this.getSessionStorageValue(storageKey) : parameterValue;
    },
    getModelFirstParameters() {
      const domainName = this.getModelFirstValueFromStorageOrUrl("Domain", "domainname");
      const tokenParam = this.getSessionStorageValue("tokenParam");
      let ModelDisplayID = tokenParam == null ? this.getModelFirstValueFromStorageOrUrl("tokenParam", "tokenParam") : null;

      const modelDisplayIdFromSource = this.getModelFirstValueFromStorageOrUrl("modelID", "modelid");
      if (modelDisplayIdFromSource != null) {
        ModelDisplayID = modelDisplayIdFromSource;
      }

      return {
        domainName,
        tokenParam,
        ModelDisplayID,
      };
    },
    resetModelFirstData() {
      this.ModelFirstData = "-";
      this.firstModel = "-";
      this.TopicModelIDData = this.ModelFirstData;
    },
    applyModelFirstResponse(response) {
      if (response.status == 0) {
        this.ModelFirstData = this.ModelFirstData == "-" ? response.data.modelDisplayID + " (" + response.data.modelName + ")" : this.ModelFirstData;
        this.firstModel = response.data.modelDisplayID + " (" + response.data.modelName + ")";
        this.TopicModelIDData = this.ModelFirstData;
        this.isAllowLLMChange = response.data.isAllowLLMChange;
        this.Time_DelayData = response.data.timeDelay;
        this.maximumChatInput = normalizeCharacterLimit(response.data.maximumChatInput, DEFAULT_CHAT_INPUT_LIMIT);
        return;
      }

      this.resetModelFirstData();
    },
    GetModelFirst(_groupmodel, _userID, _companyID) {
      try {
        const { domainName, tokenParam, ModelDisplayID } = this.getModelFirstParameters();
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? this.User_IdData,
          DomainName: domainName,
          TokenParam: tokenParam,
          ModelDisplayID: ModelDisplayID,
          CompanyID: _companyID
        };
        if (this.Log_History_TopicIDData != -1) {
          return;
        }
        this.$call.GetModelFirst(
          _Data,
          (response) => {
            this.applyModelFirstResponse(response);
          },
          () => {
            this.resetModelFirstData();
          }
        );
      } catch (e) {
        console.error(e);
        // error ignored; reset to default model-first data
        this.resetModelFirstData();
      }
    },
    GetModelFirst_Value(_groupmodel, _userID) {
      try {
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? this.User_IdData,
        };
        if (this.Log_History_TopicIDData != -1) {
          return;
        }
        this.$call.GetModelFirst(
          _Data,
          (response) => {
            if (response.status == 0) {
              this.ModelFirstData = this.ModelFirstData == "-" ? response.data.modelDisplayID + " (" + response.data.modelName + ")" : this.ModelFirstData;
              this.firstModel = response.data.modelDisplayID + " (" + response.data.modelName + ")";
              this.isAllowLLMChange = response.data.isAllowLLMChange;
              this.Time_DelayData = response.data.timeDelay;
              this.maximumChatInput = normalizeCharacterLimit(response.data.maximumChatInput, DEFAULT_CHAT_INPUT_LIMIT);
            } else {
              this.ModelFirstData = "-";
              this.firstModel = "-";
            }
          },
          () => {
            this.ModelFirstData = "-";
            this.firstModel = "-";
          }
        );
      } catch (e) {
        console.error(e);
        // error ignored; fall back to default placeholder values
        this.ModelFirstData = "-";
        this.firstModel = "-";
      }
    },
    configColor() {
      this.$call.GetConfigThem(async (response) => {
        let data = response.data;

        if (response.status == 0 && response.message != "Posted invalid data.") {
          this.ChatbotNameData = data.nameChat;
          this.ChatbotIcon = data.iconChat;

          this.FontColorTitle = data.fontColorTitle;
          this.colorThemeChat = data.colorThemeChat;
          this.SnippedcolorThemeChat = data.snippedColorThemeChat;
          this.SnippedIconData = data.snippedIcon;
          this.SnippedIconColorData = data.snippedIconColor ?? '000000';
          this.SnippedHeaderColorThemeData = data.snippedHeaderColorTheme;
          this.SnippedFontColorThemeData = data.snippedFontColorTheme ?? 'FFFFFF';
          // Snippet panel config — เก็บค่าดิบ (null=ยังไม่ตั้ง → Snippet.vue ใช้ default เอง; bool null semantics)
          this.SnippedShowModelTopicBarData = data.snippedShowModelTopicBar;
          this.SnippedTypingTextData = data.snippedTypingText;
          this.SnippedInputPlaceholderData = data.snippedInputPlaceholder;
          this.SnippedBotBubbleColorData = data.snippedBotBubbleColor;
          this.SnippedBotFontColorData = data.snippedBotFontColor;
          this.SnippedSendButtonColorData = data.snippedSendButtonColor;
          this.SnippedSendButtonVariantData = data.snippedSendButtonVariant;
          this.SnippedShowVersionData = data.snippedShowVersion;
          this.SnippedShowCharCounterData = data.snippedShowCharCounter;
          this.SnippedShowSnippedIconData = data.snippedShowSnippedIcon;
          this.SnippedDisclaimerTextData = data.snippedDisclaimerText;
          this.ChatPanelHeaderColorThemeData = data.chatPanelHeaderColorTheme ?? data.colorThemeChat;
          this.ChatPanelFontColorThemeData = data.chatPanelFontColorTheme ?? 'FFFFFF';
          this.NavbarBtnColorThemeData = data.navbarButton;
          this.NavbarTxtColorThemeData = data.navbarColorText;
          this.FullstreamWelcomeTitleData = data.fullstreamWelcomeTitle ?? FULLSTREAM_THEME_DEFAULTS.welcomeTitle;
          this.FullstreamWelcomeSubtitleData = data.fullstreamWelcomeSubtitle ?? FULLSTREAM_THEME_DEFAULTS.welcomeSubtitle;
          this.FullstreamDisclaimerTextData = data.fullstreamDisclaimerText ?? FULLSTREAM_THEME_DEFAULTS.disclaimerText;
          this.FullstreamNavbarBtnColorThemeData = data.fullstreamNavbarBtnColorTheme ?? data.navbarButton ?? FULLSTREAM_THEME_DEFAULTS.headerBackgroundColor;
          this.FullstreamNavbarTxtColorThemeData = data.fullstreamNavbarTxtColorTheme ?? data.navbarColorText ?? FULLSTREAM_THEME_DEFAULTS.headerTextColor;
          this.FullstreamNavbarIconColorThemeData = data.fullstreamNavbarIconColorTheme ?? data.fullstreamNavbarTxtColorTheme ?? data.navbarColorText ?? FULLSTREAM_THEME_DEFAULTS.headerIconColor;
          this.FullstreamChatColorThemeData = data.fullstreamChatColorTheme ?? data.colorThemeChat ?? FULLSTREAM_THEME_DEFAULTS.chatAccentColor;
          this.isImgIconChatData = data.isImgIconChat;
        }
      });
    },
    async GetStartUpImage() {
      await this.configColor();
      if (
        !this.$route.path.toLocaleLowerCase().match("snippet") &&
        !this.$route.path.toLocaleLowerCase().match("fullstream")
      ) {
        const imagePromises = [
          this.getIMG("LoginLogo.png"),
          this.getIMG("ChatIcon.png"),
          this.getIMG("NavLogo.png"),
          this.getIMG("NavBG.png"),
          this.getIMG("SubBG.png"),
          this.getIMG("SnippedLogo.png"),
        ];

        const [
          LoginLogo,
          IconChat,
          NavbarIcon,
          NavbarBackGround,
          SubNavbarBackGround,
          SnippedLogo
        ] = await Promise.all(imagePromises);

        if (
          LoginLogo ||
          IconChat ||
          NavbarIcon ||
          NavbarBackGround ||
          SubNavbarBackGround ||
          SnippedLogo
        ) {
          this.LoginLogo = LoginLogo || this.LoginLogo;
          this.IconChat = IconChat || this.IconChat;
          this.NavbarIcon = NavbarIcon || this.NavbarIcon;
          this.NavbarBackGround = NavbarBackGround || this.NavbarBackGround;
          this.SubNavbarBackGround = SubNavbarBackGround || this.SubNavbarBackGround;
          this.SnippedLogo = SnippedLogo || this.SnippedLogo;

          await this.PlaceImage();
          this.flagNav = true;
        }
      } else if (
        this.$route.path.toLocaleLowerCase().match("fullstream") ||
        this.$route.path.toLocaleLowerCase().match("snippet")
      ) {
        let NavbarBackGround = await this.getIMG("NavBG.png");
        let IconChat = await this.getIMG("ChatIcon.png");
        let NavbarIcon = await this.getIMG("NavLogo.png");
        let SnippedLogo = await this.getIMG("SnippedLogo.png");
        await Promise.all([IconChat, NavbarIcon,NavbarBackGround,SnippedLogo]).then(async (val) => {
          if (val[0] != null) {
            this.IconChat = val[0];
          }
          if (val[1] != null) {
            this.NavbarIcon = val[1];
          }
          if (val[0] != null || val[1] != null) {
            await this.PlaceImage();
            this.flagNav = true;
          }
          if (val[2] != null) {
            this.NavbarBackGround = val[2];

            // SET config background navbar fullStream set ตรงนี้เพราะแยก class fullstream-header-cover ออกมา
            let headerCoverElement = document.querySelector(".fullstream-header-cover");
            if (headerCoverElement != null) {
              headerCoverElement.style.setProperty(
                "background",
                `url('${this.NavbarBackGround}')`,
                "important"
              );
              headerCoverElement.style.setProperty(
                "background-position",
                "center",
                "important"
              );
              headerCoverElement.style.setProperty("background-size", "cover", "important");
              headerCoverElement.style.setProperty(
                "background-repeat",
                "no-repeat",
                "important"
              );
            }
          }
          if (val[3] != null) {
            this.SnippedLogo = val[3];
          }
        });
      }
    },
    PlaceImage() {
      if (this.FontColorTitle != null) {
        let header_title = document.querySelectorAll(".header-title .title");
        if (header_title != null) {
          header_title.forEach((title) => {
            title.style.color = `#${this.FontColorTitle}`;
          });
        }
      }
      if (this.NavbarIcon != null) {
        let Fusion_Logo = document.querySelector(
          "#Fusion_Logo_FullStream .v-image__image"
        );
        if (Fusion_Logo != null) {
          Fusion_Logo.style.backgroundImage = `url('${this.NavbarIcon}') `;
        }
      }
      if (this.NavbarBackGround != null) {
        let headerCoverElement = document.querySelector(".header-cover");
        if (headerCoverElement != null) {
          headerCoverElement.style.setProperty(
            "background",
            `url('${this.NavbarBackGround}')`,
            "important"
          );
          headerCoverElement.style.setProperty(
            "background-position",
            "center",
            "important"
          );
          headerCoverElement.style.setProperty("background-size", "cover", "important");
          headerCoverElement.style.setProperty(
            "background-repeat",
            "no-repeat",
            "important"
          );
        }
      }
      if (this.SubNavbarBackGround != null) {
        let headerTitleElement = document.querySelector(".header-title");
        if (headerTitleElement != null) {
          headerTitleElement.style.background = `url('${this.SubNavbarBackGround}') `;
        }
      }
    },
    async getIMG(filename) {
      return await new Promise((resolve) => {
        this.$call.GetImage(
          filename,
          async (response) => {
            this.countff++;
            if (
              !this.$route.path.toLocaleLowerCase().match("snippet") &&
              !this.$route.path.toLocaleLowerCase().match("fullstream")
            ) {
              this.flagNav = this.countff >= 5;
            } else if (this.$route.path.toLocaleLowerCase().match("fullstream")) {
              this.flagNav = this.countff >= 2;
            }
            if (response.data.size === 0) {
              resolve(null);
            } else {
              const url = await globalThis.URL.createObjectURL(new Blob([response.data]));
              resolve(url);
            }
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    NotificationTokenExpired() {
      this.$swal.fire({
        icon: "error",
        title: "Token has expired!!!",
        showConfirmButton: false,
      });
    },
  },
  updated() {
    this.PlaceImage();
  },
  async mounted() {
    this.username = Cookies.get("username");
    this.roleId = Cookies.get("roleId");
    for (let key in this.$route.query) {
      this.parameterURL[key.toLowerCase()] = this.$route.query[key];
    }
    if (!(this.$route.path != null && this.$route.path.toLocaleLowerCase() != "/login")) {
      this.GetStartUpImage();
    }
    // รอจนกว่า that.$router.currentRoute.value.name จะไม่เป็น undefined
    const waitForRouteName = async () => {
      while (this.$router.currentRoute.value.name === undefined) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
    };
    await waitForRouteName();
    if (this.$router.currentRoute.value.name === "FullStream") {
      if (
        this.$route.query.snippet == null ||
        this.$route.query.snippet == undefined ||
        this.$route.query.snippet == "" ||
        this.$route.query.snippet == false //NOSONAR
      ) {
        this.store.commit('setSnippetStatus', false);
        this.Snippet_StatusData = false;
      } else {
        this.store.commit('setSnippetStatus', true);
        this.Snippet_StatusData = true;
      }
    } else if (this.$router.currentRoute.value.name === "Snippet") {
      if (this.$route.query.flagnavbar == "true") {
        this.store.commit('setSnippetStatus', false);
        this.Snippet_StatusData = false;
      } else {
        this.store.commit('setSnippetStatus', true);
        this.Snippet_StatusData = true;
      }
    } else {
      // that.FF  = "s3"
    }
    
  },
};
</script>
<style>
/* Global font settings for the entire application */
.v-application {
  font-family: 'Poppins', 'Noto Sans Thai', sans-serif !important;
  min-height: 100vh !important;
  width: 100% !important;
}

.v-application *,
.v-application .v-btn,
.v-application .v-list-item,
.v-application .v-card,
.v-application .v-dialog,
.v-application .v-toolbar,
.v-application .v-navigation-drawer {
  font-family: inherit !important;
}

/* Thai text specific styling */
.v-application *[lang="th"],
.v-application .thai-text {
  font-family: 'Noto Sans Thai', 'Poppins', sans-serif !important;
}

/* English text specific styling */
.v-application *[lang="en"],
.v-application .english-text {
  font-family: 'Poppins', 'Noto Sans Thai', sans-serif !important;
}

.v-content__wrap {
  background-color: #f0f0f7;
  min-height: calc(100vh - 64px);
  width: 100%;
}

.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}

/* เพิ่ม CSS เพื่อให้แน่ใจว่า Vuetify components มีขนาดเต็มจอ */
.v-application__wrap {
  min-height: 100vh !important;
}
</style>
